// This addresses a known issue with OpenLayers and newer Chromium browsers where
// frequent canvas readback operations cause performance warnings. By setting `willReadFrequently: true`
// simplifies the browser's internal optimization for this use case (hit detection, etc).
//
// Reference warning: ExecutorGroup.js:163 Canvas2D: Multiple readback operations using getImageData
// are faster with the willReadFrequently attribute set to true.

if (
  typeof HTMLCanvasElement !== 'undefined' &&
  HTMLCanvasElement.prototype &&
  HTMLCanvasElement.prototype.getContext
) {
  const originalGetContext = HTMLCanvasElement.prototype.getContext
  HTMLCanvasElement.prototype.getContext = function (type, options) {
    if (type === '2d') {
      const newOptions = options ? { ...options } : {}
      newOptions.willReadFrequently = true
      return originalGetContext.call(this, type, newOptions)
    }
    return originalGetContext.call(this, type, options)
  }
}
